<template>
    <div>
        <breadcrumbs
            :title="'Suorganizatori'"
            :breadcrumbs="breadcrumbs"
        ></breadcrumbs>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Novi suorganizator</h5>
            </div>
            <div class="ibox-content">
                <suorganizator-forma
                    :disabled="false"
                    :id="null"
                    :modal="false"
                    :action="'create'"
                ></suorganizator-forma>
            </div>
        </div>
    </div>
</template>

<script>
import Breadcrumbs from "../../../../components/breadcrumbs/Breadcrumbs";
import SuorganizatorForma from "./SuorganizatorForma";
export default {
    name: "SuorganizatorCreate",
    components: {
        SuorganizatorForma,
        Breadcrumbs
    },
    data(){
        return {
            breadcrumbs: []
        }
    },
    methods: {
        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/postavke/suorganizatori',
                    name: 'Suotganizatori'
                },
                {
                    path: '/postavke/suorganizatori/create',
                    name: 'Novi suorganizator'
                }
            ]
        }
    },
    mounted(){
        this.setBreadcrumbs()
    }
};
</script>

<style scoped>

</style>
